module.exports = __webpack_public_path__ + "static/media/gofore.4ca30de2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/gofore.svg
// module id = 127
// module chunks = 0